import React, {useEffect, useState} from 'react';
import {
    ReactComponent as CalendarIcon
} from '../../../../../../assets/main/groups/main-table/period-calendar/calendar.svg';
import {ReactComponent as PlusIcon} from '../../../../../../assets/main/groups/main-table/period-calendar/plus.svg';
import {CalendarWith} from "./calendar-with/Calendar-with";
import {CalendarTo} from "./calendar-to/Calendar-to";
import {Link, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "common/hook";
import {ROLE_DEMO_STUDENT, ROLE_HR, ROLE_TEACHER} from "entities/constants/constants";
import {fetchLessonsByGroupsId} from "features/model/service/groups/groups-lessons/fetchLessonsByGroupsId";
import {fetchLessonsDemo} from "features/model/service/lessons/lessons-demo/fetchLessonsDemo";
import {CompanySummaryTable} from "features/model/types/hr/getSummaryTable";
import {getSummaryTable} from "features/model/service/hr/get-summary-table/getSummaryTable";
import {getSummaryTableExcel} from "features/model/service/hr/get-summary-table-excel/getSummaryTableExcel";


interface IPeriodCalendar {
    create: boolean
    print: boolean
    company?: CompanySummaryTable
    setCurrentFrom?: (value: string) => void;
    setCurrentTo?: (value: string) => void;
    value?: number;
}

export const PeriodCalendar = ({create, print, company, setCurrentFrom, setCurrentTo,value}: IPeriodCalendar) => {
    const roleType = useAppSelector((state) => state.role.roleType);
    const dispatch = useAppDispatch();
    const [isOpenWith, setIsOpenWith] = useState(false);
    const [isOpenTo, setIsOpenTo] = useState(false);
    const from = useAppSelector((state) => state.date.dateWith);
    const to = useAppSelector((state) => state.date.dateTo);
    const fromNew = useAppSelector((state) => state.date.dateWithNew);
    const toNew = useAppSelector((state) => state.date.dateToNew);
    const groupId = useParams().groupId!;
    const Loading = useAppSelector((state) => state.groupsLessons.IsLoading);
    const [isLoading, setIsLoading] = useState(Loading);







    const fetchData = (dispatchFn: any, params: any) => {
        setIsLoading(true);

        dispatchFn(params)
            .then(() => {
                setIsLoading(false);
            })
            .catch((error: string) => {
                console.error('Error fetching lessons:', error);
                setIsLoading(false);
            });
    };


    useEffect(() => {
        if (roleType === ROLE_DEMO_STUDENT) {
            if (from && to) {
                fetchData(dispatch, fetchLessonsDemo({from, to}));
            }
        } else if (roleType === ROLE_HR && !window.location.pathname.includes('/groups/')) {
            if (from && to) {
                fetchData(dispatch, getSummaryTable({from, to}));
            }
        } else {
            fetchData(dispatch, fetchLessonsByGroupsId({groupId, from, to}));
            setCurrentFrom?.(from);
            setCurrentTo?.(to);
        }
    }, [dispatch, roleType, groupId, from, to]);


    const togglePopupWith = () => {
        setIsOpenWith(!isOpenWith);
        setIsOpenTo(false);
    };

    const togglePopupTo = () => {
        setIsOpenTo(!isOpenTo);
        setIsOpenWith(false);
    };

    const handleClose = () => {
        setIsOpenWith(false);
        setIsOpenTo(false);
    };


    const downloadExcelHandler = () => {
        dispatch(getSummaryTableExcel({from, to}));
    }


    return (
        <div className="tabs-content">
            {print && (
                <div className="data-tbl-title-box">
                    <div className="title-col">
                        <p className="h3">{company?.title}</p>
                    </div>

                    <div className="sub-col">
                        <span className="btn secondary small print-action" onClick={downloadExcelHandler}>
                            <span>Распечатать отчёт</span>
                        </span>
                    </div>
                </div>
            )}
            <div className="tab">
                <div className="data-tbl-controls">
                    <div className="period-control">
                        <span className="text">Период с</span>
                        <span onClick={togglePopupWith} className="open-calendar-btn">
                            <span className='date-width'>{fromNew || null}</span>
                            <CalendarIcon/>
                        </span>
                        <span className="text">по</span>
                        <span onClick={togglePopupTo} className="open-calendar-btn">
                            <span className='date-width'>{toNew || null}</span>
                            <CalendarIcon/>
                        </span>
                    </div>

                    {roleType === ROLE_TEACHER && (
                        <>
                            {create && (
                                <Link to={`/groups/${groupId}/add-lesson`} className="btn small has-icon">
                                    <span className="icon">
                                        <PlusIcon/>
                                    </span>
                                    <span>Создать занятие</span>
                                </Link>
                            )}
                        </>
                    )}
                </div>
            </div>
            <>
                {isOpenWith && <CalendarWith onClose={handleClose}/>}
                {isOpenTo && <CalendarTo onClose={handleClose}/>}
            </>
        </div>
    );
};

